/* --------------------------------------------------------------------------------------
   print.module.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/
import { printBrowseComponent } from "./components/printBrowse.component";
import { printSettingsComponent } from "./components/printSettings.component";
import { printActionBarComponent } from "./components/printActionBar.component";
import { printSettingsFileSectionComponent } from "./components/printSettingsFileSection.component";
import { printSettingsPrintSectionComponent } from "./components/printSettingsPrintSection.component";
import { printModuleService } from "./services/printModule.service";

export const appPrintModule = angular
  .module("app.print", [])
  .component("printBrowse", printBrowseComponent)
  .component("printSettings", printSettingsComponent)
  .component("printActionBar", printActionBarComponent)
  .component("printSettingsFileSection", printSettingsPrintSectionComponent)
  .component("printSettingsPrintSection", printSettingsFileSectionComponent)
  .service("printModuleService", printModuleService);



// WEBPACK FOOTER //
// ./src/app/print/print.module.js